module["exports"] = [
  "ul.",
  "al."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/street_prefix.js
// module id = 1227
// module chunks = 0